// @flow

import { v4 as uuidv4 } from 'uuid'

import type { ChatBubbleMessage } from '@chatchamp/chatchamp-types'

import { MESSAGE_TYPE_SET_ITEM } from '../../../../common/iframeMessageTypes'
import { isYoungerThanSeconds } from '../../../../common/time'

import { LAST_MESSAGE_RECEIVED_COOKIE_NAME } from '../../../models'
import { isTypingOffMessage, isTypingOnMessage, isVisibleMessage } from '../../../models/Message'
import { postMessageToParent } from '../../../utils/iframe'

import type { RootState } from '../../rootState'

import { processNewMessage } from './processNewMessage'
import type { MessagesState } from './state'

type MessageAction = {
  commit: any,
  dispatch: any,
  state: MessagesState,
  rootState: RootState,
  getters: any
}

export const actions = {
  setMessageHistory ({
    commit,
    state,
    dispatch
  }: MessageAction, messages: Array<ChatBubbleMessage<any>>) {
    const lastMessage = messages[messages.length - 1]
    let delay = 0
    if (lastMessage) {
      if (isTypingOnMessage(lastMessage)) {
        commit('setTypingIndicator', true)
      } else if (isTypingOffMessage(lastMessage)) {
        commit('setTypingIndicator', false)
      }
      // $FlowFixMe
      if (isYoungerThanSeconds(lastMessage.createdAt, 10)) {
        dispatch('lastMessageReceived', new Date().toISOString())
        delay = processNewMessage({
          state,
          commit
        }, lastMessage)
      }
    }
    if (delay) {
      setTimeout(() => {
        commit('setMessages', messages)
      }, delay * 1000)
    } else {
      commit('setMessages', messages)
    }
    if (!state.autoScroll) {
      // $FlowFixMe
      commit('increaseUnreadMessagesCount', messages.filter(m => m.new === true).filter(isVisibleMessage).length)
    } else {
      commit('resetUnreadMessagesCount', 0)
    }
  },
  clearClientSideMessages ({ state }: MessageAction) {
    state.messages = state.messages.filter(msg => !state.clientSideMessageIds.includes(msg.id))
    state.clientSideMessageIds = []
  },
  addTextMessageToList ({
    state,
    rootState
  }: MessageAction, text: string) {
    const id = uuidv4()
    state.clientSideMessageIds.push(id)
    state.messages.push({
      id,
      from: rootState.subscriberId,
      to: rootState.customerId,
      type: 'message',
      status: 'sent',
      content: {
        text: text
      }
    })
  },
  lastMessageReceived ({
    commit,
    getters
  }: MessageAction, timestamp: ?Date) {
    commit('setLastMessageReceived', timestamp)
    postMessageToParent({
      event: MESSAGE_TYPE_SET_ITEM,
      key: LAST_MESSAGE_RECEIVED_COOKIE_NAME,
      value: timestamp,
      maxAgeDays: getters.channel.cookieMaxAgeInDays()
    })
  }
}
